import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
	
	const currentPath = useLocation()

	useEffect(() => {
		  if(currentPath?.pathname !== "/"){
			  window.scroll({
				  top: 0,
				  left: 0,
				  behavior: 'smooth'
			  })
		  }
	  },[currentPath?.pathname])

	return (
		<React.Fragment />
	);
};

export default ScrollToTop;